/* Run24 — reveal on scroll (basado en design-reference/app/motion.jsx)
   Uso: data-r24-reveal en cualquier elemento; data-r24-reveal-stagger en un
   contenedor aplica delays incrementales a sus hijos directos.
   Respeta prefers-reduced-motion. */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || !('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-r24-reveal], [data-r24-reveal-stagger]').forEach(function (el) {
      el.classList.add('is-inview');
    });
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          io.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
  );

  function init(root) {
    root.querySelectorAll('[data-r24-reveal-stagger]').forEach(function (group) {
      Array.prototype.forEach.call(group.children, function (child, i) {
        child.style.transitionDelay = Math.min(i * 60, 360) + 'ms';
      });
    });
    root.querySelectorAll('[data-r24-reveal], [data-r24-reveal-stagger]').forEach(function (el) {
      io.observe(el);
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
